import script from "./AdminUsuarios.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUsuarios.vue?vue&type=script&setup=true&lang=js"

import "./AdminUsuarios.vue?vue&type=style&index=0&id=2cf2b956&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf2b956"]])

export default __exports__